import { $authHost } from './index';
 
export default class ReportService {
    static async getUniversalReport(params) {
        return $authHost.post('/api/reports/universal', params);
    }
} 